jQuery( function ($) {
  $('a[href^="#"]').on('click', function(event) {
    event.preventDefault();
    const target = $(this.getAttribute('href'));
    const headerHeight = $('.js-header').outerHeight(); // ヘッダーの高さを取得

    if (target.length) {
        $('html, body').stop().animate({
            scrollTop: target.offset().top - headerHeight - 32 // ヘッダーの高さを差し引きます
        }, 500);
    }
  });
} );